import yup from 'src/libraries/validator.library';
import {
  ITailNumberForm,
  TailNumberResponsePayloadSchema,
  TailNumberListSchema,
} from 'src/models/tail-number.model';
import { httpClient } from 'src/libraries/http.library';

const http = httpClient();

const services = {
  listGET: async () => {
    return http.get('tailNumber', { limit: 0 }, TailNumberListSchema);
  },
  updatePUT: async (id: number, data: ITailNumberForm) => {
    return http.put(`tailNumber/${id}`, data, TailNumberResponsePayloadSchema);
  },
  addPOST: async (data: ITailNumberForm) => {
    return http.post('tailNumber', data, TailNumberResponsePayloadSchema);
  },
  itemDELETE: async (id: number) => {
    return http.delete(`tailNumber/${id}`, yup.mixed());
  },
};

export default services;
